var vertical_embed_viewer_default = {
  "card": "_-3SF6",
  "slimLayout": "yY3cV",
  "cardLayout": "K3C17",
  "imageContainer": "DGd-k",
  "image": "GdIu3",
  "content": "cGRmc"
};
export {
  vertical_embed_viewer_default as default
};
//# sourceMappingURL=vertical-embed-viewer-scss.js.map
